module.exports = __webpack_public_path__ + "img/mouse3-fill.c52755b9.svg";